import { debounce } from "@mui/material";
import { useState } from "react";

export interface GroupedTableSearchProps {
  searchValue: string;
  onInputChange: (searchValue: string, reason: string) => void;
  placeholder?: string;
  position: {
    top?: string | number;
    left?: string | number;
    bottom?: string | number;
    right?: string | number;
  };
}

type Props = {
  position: {
    top?: string | number;
    left?: string | number;
    bottom?: string | number;
    right?: string | number;
  };
  placeholder?: string;
};

const useGroupedTableSearch = ({ position, placeholder = "" }: Props) => {
  const [searchValue, setSearchValue] = useState("");

  const onInputChange = debounce((value: string, reason: string) => {
    if (reason === "input") {
      setSearchValue(value);
    }
  }, 500);

  const searchProps: GroupedTableSearchProps = {
    searchValue,
    onInputChange,
    placeholder,
    position,
  };

  return searchProps;
};

export default useGroupedTableSearch;
